import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../web/components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		boxSizing: 'border-box',
		flexDirection: 'column',
		gap: 20,
		maxWidth: 968,
		margin: '0 auto',
		padding: 16,

		'@media (min-width: 900px)': {
			marginTop: THEME.spacing.lg,
			padding: 0,
		},
	},

	thankYouContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: 40,
		width: '100%',
		padding: 16,
	},
	illustrationContainer: {
		width: '100%',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	illustration: {
		width: '100%',
		objectFit: 'contain',

		[`@media (min-width: ${THEME.breakpoints.md}px)`]: {
			width: '100%',
			maxWidth: 500,
		},
	},
	thankYouMessage: {
		fontSize: 24,
		fontWeight: 600,
	},
	thankYouButtonContainer: {
		display: 'flex',
		width: '100%',
		alignItems: 'center',
		justifyContent: 'center',
	},
	thankYouButton: {
		width: 400,
	},
	thankYouMessageContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: 8,
		alignItems: 'center',
		justifyContent: 'center',
	},
});
